// extracted by mini-css-extract-plugin
module.exports = {"infoPopup":"infoPopup_infoPopup__1wW7f","infoPopupText":"infoPopup_infoPopupText__1pstJ","infoPopupImage":"infoPopup_infoPopupImage__1xamU"};